import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { RawHardwareSessionData } from './types'

export const hardwareSessionsAdapter =
  createEntityAdapter<RawHardwareSessionData>()

export const initialHardwareSessionsState =
  hardwareSessionsAdapter.getInitialState({
    selectedTeamId: null
  })

export const hardwareSessionsSlice = createSlice({
  name: 'hardwareSessions',
  initialState: initialHardwareSessionsState,
  reducers: {
    upsertOne: hardwareSessionsAdapter.upsertOne,
    upsertMany: hardwareSessionsAdapter.upsertMany,
    removeOne: hardwareSessionsAdapter.removeOne,
    removeAll: hardwareSessionsAdapter.removeAll
  }
})

export const reducer = hardwareSessionsSlice.reducer

export const {
  upsertOne: upsertHardwareSession,
  upsertMany: upsertHardwareSessions,
  removeOne: removeHardwareSession,
  removeAll: removeAllHardwareSessions
} = hardwareSessionsSlice.actions
